/**
 * description 轮播动画
 * created by zhang.yingyu
 * modified on 2018-03-29
 */
"use strict";
angular.module("carouselModule", [])
    .directive("broadCarousel",['$timeout','eventAnalysisService',function($timeout,eventAnalysisService){
    return {
        replace: false,
        scope: {
            sliderPicValue: "="
        },
        restrict: "AE",
        templateUrl: "./planningCenter/eventAnalysis/directive/carousel/carousel_tpl.html",
        link: function(scope,elem, iAttrs, controller) {
            $timeout(function(){
                scope.$watch("sliderPicValue", function (newVal, oldVal) {
                    if (typeof newVal == 'object') {
                        scope.status={
                            containerW:$(elem).find(".carousel_skele_container").width(),
                            imgLen:scope.sliderPicValue.length,
                            index:1,
                            showBtn:false
                        };
                        var c_cont = $(elem).find(".carousel_container")[0];
                        var c_skele = $(elem).find(".carousel_skele")[0];
                        var circle_len=$(elem).find(".circle_btn span");
                        $(elem).find(".carousel_skele").width( scope.status.containerW*(scope.status.imgLen+2)+'px');
                        $(elem).find(".carousel_skele").css("left",-scope.status.containerW+'px');
                        var timer = null,timer2 = null;
                        var state = false;
                        $($(elem).find(".circle_btn span")[0]).addClass("active");
                       var showButton=function(){
                            $($(elem).find(".circle_btn span")[0]).removeClass("active");
                            for(var i=0;i<circle_len.length;i++){
                                if(circle_len[i].className=="active"){
                                    circle_len[i].className="";
                                    break;
                                }
                            }
                            if(scope.status.imgLen){
                                circle_len[ scope.status.index-1].className="active";
                            }

                        };
                        var animate=function(offset){
                            state = true;
                            var time = 220,interval = 8,speed = offset/(time/interval);
                            var calculate_left = parseInt(c_skele.style.left) + offset;
                            function go(){
                                clearInterval(timer);
                                if((speed < 0 && parseInt(c_skele.style.left) >calculate_left) || (speed > 0 && parseInt(c_skele.style.left) <calculate_left)){
                                    c_skele.style.left = parseInt(c_skele.style.left) + speed + "px";
                                    timer=setInterval(go,interval);
                                }else{
                                    state = false;
                                    c_skele.style.left =calculate_left + "px";
                                    if(parseInt(c_skele.style.left) < -scope.status.containerW*scope.status.imgLen){
                                        c_skele.style.left = -scope.status.containerW + "px";
                                    }
                                    if(parseInt(c_skele.style.left) > -scope.status.containerW){
                                        c_skele.style.left = -scope.status.containerW*scope.status.imgLen + "px";
                                    }
                                }
                            }
                            go();

                        };
                        var playCarousel=function(){
                            timer2 = setInterval(function(){
                                scope.moveToRight();
                            },2000);
                        };
                        var stopCarousel=function(){
                            clearInterval(timer2);
                        };
                        //显示按钮
                        scope.showBtn=function(){
                            scope.status.showBtn=true;
                        };
                        scope.hideBtn=function(){
                            scope.status.showBtn=false;
                        };
                        scope.getCircleIndex=function(index){
                            index=index+1;
                            var offset = (index- scope.status.index) * -scope.status.containerW;
                            if(state){
                                return;
                            }
                            animate(offset);
                            scope.status.index =index;
                            showButton();
                        };

                        // 向右移动
                        scope.moveToRight=function(){
                            if(state){
                                return;
                            }
                            animate(-scope.status.containerW);
                            if(scope.status.index==scope.status.imgLen){
                                scope.status.index=1;
                            }else{
                                scope.status.index++;
                            }
                           showButton();

                        };
                        // 向左移动
                        scope.moveToLeft=function(){
                            if(state){
                                return;
                            }
                           animate(scope.status.containerW);
                            if(scope.status.index==1){
                                scope.status.index=scope.status.imgLen;
                            }else{
                                scope.status.index--;
                            }
                            showButton();

                        };
                        playCarousel();
                        c_cont.onmouseover = stopCarousel;
                        c_cont.onmouseout = playCarousel;
                        scope.getPicValue=function(index,value){
                            eventAnalysisService.showBigPictureModal(index,value).then(function(){});
                        };
                    }
                });




            });

        }
    }
}]);

